import { BackgroundCheckRequest } from '@juvare/platform-app/Integration';
import { defineColumns, EntityColumns } from '@juvare/platform-shared/features/storage';
import { ParsedBackgroundCheck } from '../../platform-functions/utils';
import { BackgroundCheckStatus, BackgroundCheckType } from '../../types';

export const backgroundCheckHistoryEntityName = 'backgroundCheckHistory';

export interface BackgroundCheckHistoryData {
    accountId: string;
    type: BackgroundCheckType;
    prevStatus?: BackgroundCheckStatus;
    nextStatus?: BackgroundCheckStatus;
    requestId?: string;
    checkResponseByRequestId?: string;
    responseXml?: string;
    request?: BackgroundCheckRequest;
    message?: string; // system generated
    note?: string; // human entered
    document?: BackgroundCheckDocument;
    isUsingQuota?: boolean;
    createdAt?: number;
    isManualChange?: boolean;
    parsedXml?: ParsedBackgroundCheck;
    internalStatusChange?: boolean;
}

export interface BackgroundCheckDocument {
    entityKey: string;
    name: string;
    size: number;
    url: string;
}

export const backgroundCheckHistoryColumns = defineColumns({
    accountId: {
        type: 'id-required',
        index: true,
    },
    type: {
        type: 'string-required',
        index: true,
    },
    prevStatus: {
        type: 'string',
    },
    nextStatus: {
        type: 'string',
    },
    checkResponseByRequestId: {
        type: 'string',
        index: true,
    },
    message: {
        type: 'string',
    },
    note: {
        type: 'string',
    },
    createdAt: {
        type: 'number',
    },
    isUsingQuota: {
        type: 'boolean',
        index: true,
    },
    withDocument: {
        type: 'boolean-required',
    },
});

export type BackgroundCheckHistoryColumns = EntityColumns<typeof backgroundCheckHistoryColumns>;
